import { AutogenModelEdiLtxexpressProf, AutogenRowEdiLtxexpressProf } from "./autogen/AutogenModelEdiLtxexpressProf";

export class ModelEdiLtxexpressProf extends AutogenModelEdiLtxexpressProf<RowEdiLtxexpressProf> {
    constructor() {
        super(RowEdiLtxexpressProf);
    }
}

export class RowEdiLtxexpressProf extends AutogenRowEdiLtxexpressProf {
}